export default __webpack_public_path__ + "static/media/services_parking.d1797117.svg";